import React, { useState } from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";
import placeholderImg from "../../assets/images/sailing.jpg";
import { useFilter } from "../../context/FilterProjectsContext";
import seoAssistantImg from "../../assets/images/seoassistant2.jpg";
import arncAIImg from "../../assets/images/arncai.jpg";
import mertShopImg from "../../assets/images/mertshop.jpg";
import pixelPalsImg from "../../assets/images/pixelpals.jpg";
import liveMapImg from "../../assets/images/livemap_img.jpg";
import arncCloudImg from "../../assets/images/arncloud1.jpg";
import kioskQuizImg from "../../assets/images/kioskQuiz1.jpg";
import talksAIImg from "../../assets/images/talksAI1.jpg";
import eventImg from "../../assets/images/event.jpg";

const Overview = ({ onSelect }) => {
  const { selectedFilter, activeFolder, setSelectedFilter, setActiveFolder } =
    useFilter();

  const handleChange = (folderName) => {
    setActiveFolder(folderName);
    if (onSelect) {
      onSelect(folderName);
    }
    setSelectedFilter(folderName);
    // Scroll to top when project changes
    setTimeout(() => {
      const projectsPanel = document.querySelector(".projects-panel.panel");
      if (projectsPanel) {
        projectsPanel.scrollTo(0, 0);
      }
    }, 0);
  };

  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content projects-overview">
        <p className="projects-comment">// Few of my projects to display</p>
        <div className="projects-row">
          <div className="projects-col project">
            <img src={liveMapImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">liveMap</p>
              <p className="project-desc">
                Developed a custom interactive map system for Venture Marine
                Services using Mapbox. Integrated Mapbox Studio for tailored map
                design and implemented advanced JavaScript to handle dynamic
                location changes and smooth zoom transitions. The system was
                built to support real-time vessel tracking, with architecture
                prepared for MarineTraffic API integration.
              </p>
              <button
                onClick={() => {
                  handleChange("livemap");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={arncAIImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">arncAI</p>
              <p className="project-desc">
                arncAI is a custom AI chatbot platform similar to ChatGPT, but
                powered by Gemini API. It features user authentication,
                session-based chat history, and a clean React frontend. The
                backend is built with Node.js, Express, and SQL, enabling secure
                user management and persistent conversations across sessions.
              </p>
              <button
                onClick={() => {
                  handleChange("mertgpt");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={seoAssistantImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">autoSEO</p>
              <p className="project-desc">
                AutoSEO is a custom-built WordPress plugin that analyzes your
                website content and provides AI-generated SEO suggestions,
                including meta titles, descriptions, and slugs, using Gemini
                API. The backend, built with Node.js, handles all requests and
                content parsing. By scanning entire pages, it delivers optimized
                suggestions that help boost your site's SEO performance.
              </p>
              <button
                onClick={() => {
                  handleChange("autoseo");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
        </div>
        <div className="projects-row mt-25">
          <div className="projects-col project">
            <img src={arncCloudImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">mertCloud</p>
              <p className="project-desc">
                A private cloud storage solution built with React, Node.js,
                Express, and Multer. It supports chunk-based uploads to optimize
                performance and reliability for large files.
              </p>
              <button
                onClick={() => {
                  handleChange("mertcloud");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={kioskQuizImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">kioskQuiz</p>
              <p className="project-desc">
                kioskQuiz is a full-stack system for collecting user data and
                enforcing mandatory safety tests before terminal access. Built
                with React, Express.js, and SQL, it features user/admin
                accounts, QR-based invitations, and a daily cron job that shares
                applicant info with security teams.
              </p>
              <button
                onClick={() => {
                  handleChange("kioskquiz");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={talksAIImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">talks.AI</p>
              <p className="project-desc">
                An AI coaching platform where users join Zoom-like calls with an
                AI coach, discuss any topic, receive smart summaries, and get
                personalized plans. Includes persistent chat with memory,
                complex auth, and multiple API integrations. Built with Next.js,
                PostgreSQL, and OpenAI API.
              </p>
              <button
                onClick={() => {
                  handleChange("talksai");
                }}
                className="view-project-btn coming-soon"
              >
                coming-soon
              </button>
            </div>
          </div>
        </div>
        <div className="projects-row mt-25">
          <div className="projects-col project">
            <img
              src={pixelPalsImg}
              alt=""
              className="project-img pixelPalsImg"
            />
            <div className="project-details">
              <p className="project-name">pixelPals</p>
              <p className="project-desc">
                A real-time pixel pet game where players buy, sell, and trade
                unique animals using in-game currency. Each pet has its own
                behavior logic—getting hungry, sleepy, or interacting with
                others. Powered by React, Node.js, MongoDB, and WebSocket for a
                dynamic, server-driven experience.
              </p>
              <button
                onClick={() => {
                  handleChange("pixelpals");
                }}
                className="view-project-btn"
              >
                view-project
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={eventImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">eventInv</p>
              <p className="project-desc">
                An event invitation system with a custom backend and lightweight
                frontend. Personalized email invites are sent via the backend,
                generating unique QR codes upon acceptance. At the entrance, QR
                codes are scanned to track attendance, with real-time check-in
                data shown on a dashboard.
              </p>
              <button
                onClick={() => {
                  handleChange("eventinv");
                }}
                className="view-project-btn coming-soon"
              >
                coming-soon
              </button>
            </div>
          </div>
          <div className="projects-col project">
            <img src={mertShopImg} alt="" className="project-img" />
            <div className="project-details">
              <p className="project-name">mertShop</p>
              <p className="project-desc">
                A simple online shopping site built with React and Strapi—one of
                my first full projects experimenting with new technologies. It
                includes a functional Stripe integration for payments and laid
                the foundation for many webshops I’ve built since.
              </p>
              <button
                onClick={() => {
                  handleChange("mertshop");
                }}
                className="view-project-btn coming-soon"
              >
                coming-soon
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
